
const appConfig = window.AppConfig || {};

let initialized = false;
let configs;

/**
 * Set and valid configs from process.env.
 *
 * @throws {Error} Will throw error if validation fails.
 */
export const initConfigs = () => {
  configs = {
    API_ENDPOINT: appConfig.REACT_APP_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT || '',
    CHECK_SERVICEABILITY: appConfig.REACT_APP_CHECK_SERVICEABILITY || process.env.REACT_APP_CHECK_SERVICEABILITY || '',
    SHOW_BUNDLE: appConfig.REACT_APP_SHOW_BUNDLE || process.env.REACT_APP_SHOW_BUNDLE || '',
    EXPRESS_VAS: appConfig.REACT_APP_EXPRESS_VAS || process.env.REACT_APP_EXPRESS_VAS || '',
    CHASEPAYMENT_URL_GETKEY: appConfig.REACT_APP_CHASEPAYMENT_URL_GETKEY || process.env.REACT_APP_CHASEPAYMENT_URL_GETKEY || '',
    CHASEPAYMENT_URL_ENCRYPTION: appConfig.REACT_APP_CHASEPAYMENT_URL_ENCRYPTION || process.env.REACT_APP_CHASEPAYMENT_URL_ENCRYPTION || '',
    APP_VERSION: appConfig.REACT_APP_APP_VERSION || process.env.REACT_APP_APP_VERSION || '1.0',
    BUSINESS_PARTNER: appConfig.REACT_APP_BUSINESS_PARTNER || process.env.REACT_APP_BUSINESS_PARTNER || 'elnkwww',
    RESIDENTIAL_PARTNER: appConfig.REACT_APP_RESIDENTIAL_PARTNER || process.env.REACT_APP_RESIDENTIAL_PARTNER || 'elnkafil',
    SMARTY_API_KEY: appConfig.REACT_APP_SMARTY_API_KEY || process.env.REACT_APP_SMARTY_API_KEY || '',
    RESULTS_URL: appConfig.REACT_APP_RESULTS_URL || process.env.REACT_APP_RESULTS_URL || 'http://results.earthlink.com/',
    BASE_URL: appConfig.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || 'http://results.earthlink.com/',
    SHOW_SCHEDULE_APPT: appConfig.REACT_APP_SHOW_SCHEDULE_APPT || process.env.REACT_APP_SHOW_SCHEDULE_APPT || false,
    SHOW_PSWD_CQAS: appConfig.REACT_APP_SHOW_PSWD_CQAS || process.env.REACT_APP_SHOW_PSWD_CQAS || false,

    SHOW_MOBILE_OPTIONS: appConfig.REACT_APP_SHOW_MOBILE_OPTIONS || process.env.REACT_APP_SHOW_MOBILE_OPTIONS || 'false',
    SHOW_CALL_NOW: appConfig.REACT_APP_SHOW_CALL_NOW || process.env.REACT_APP_SHOW_CALL_NOW || false,
    SHOW_TERMS_CONTRACT: appConfig.REACT_APP_SHOW_TERMS_CONTRACT || process.env.REACT_APP_SHOW_TERMS_CONTRACT || 'false',
    LEADS_SDK_SCRIPT_SRC: appConfig.REACT_APP_LEADS_SDK_SCRIPT_SRC || process.env.REACT_APP_LEADS_SDK_SCRIPT_SRC || '',
    TURNSTILE_SITE_KEY: appConfig.REACT_APP_TURNSTILE_SITE_KEY || process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
    HEADLESS_CHECKOUT_BASE_URL: appConfig.REACT_APP_HEADLESS_CHECKOUT_BASE_URL || process.env.REACT_APP_HEADLESS_CHECKOUT_BASE_URL || 'https://checkout.earthlink.com',
    GOOGLE_CLIENT_ID: appConfig.REACT_APP_GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    GOOGLE_USERINFO_URL: appConfig.REACT_APP_GOOGLE_USERINFO_URL || process.env.REACT_APP_GOOGLE_USERINFO_URL || 'https://www.googleapis.com/oauth2/v3/userinfo',
    APPLE_CLIENT_ID: appConfig.REACT_APP_APPLE_CLIENT_ID || process.env.REACT_APP_APPLE_CLIENT_ID || '',
    APPLE_REDIRECT_URI: appConfig.REACT_APP_APPLE_REDIRECT_URI || process.env.REACT_APP_APPLE_REDIRECT_URI || '',
    BUYFLOW_ENABLED: '',
  };

  if (!/^http(s)?:/i.test(configs.API_ENDPOINT)) {
    throw new Error('Expected REACT_APP_API_ENDPOINT to be valid uri');
  }
  if (!/^http(s)?:/i.test(configs.CHECK_SERVICEABILITY)) {
    throw new Error('Expected REACT_APP_CHECK_SERVICEABILITY to be valid uri');
  }
  if (!/^http(s)?:/i.test(configs.CHASEPAYMENT_URL_GETKEY)) {
    throw new Error('Expected REACT_APP_CHASEPAYMENT_URL_GETKEY to be valid uri');
  }
  if (!/^http(s)?:/i.test(configs.CHASEPAYMENT_URL_ENCRYPTION)) {
    throw new Error('Expected REACT_APP_CHASEPAYMENT_URL_ENCRYPTION to be valid uri');
  }
  if (!configs.SMARTY_API_KEY || configs.SMARTY_API_KEY === '') {
    throw new Error('REACT_APP_SMARTY_API_KEY is required');
  }
  if (!/^http(s)?:/i.test(configs.EXPRESS_VAS)) {
    throw new Error('Expected EXPRESS_VAS to be valid uri');
  }

  initialized = true;
};

/**
 * Get configs.
 *
 * @throws {Error} Will throw error if configs have not been initialized.
 */
export const getConfigs = () => {
  if (!initialized) {
    initConfigs();
  }
  return configs;
};

/**
 * Set allowed config value by key.
 */
export const setConfig = (key, value) => {
  if (!initialized) {
    initConfigs();
  }

  const mutableConfigKeys = {
    'BUYFLOW_ENABLED': ['true', 'false'],
  };

  if (Object.prototype.hasOwnProperty.call(configs, key) && (mutableConfigKeys?.[key]?.includes(value) || mutableConfigKeys?.[key]?.length === 0)) {
    configs[key] = value;
  }
}

/**
 * The Google OAuth Client ID for "Continue with Google" - empty string when unconfigured.
 */
export const getGoogleClientId = () => getConfigs().GOOGLE_CLIENT_ID;

/**
 * Google's OAuth userinfo endpoint, used to fetch the signed-in user's name/email for prefill.
 */
export const getGoogleUserInfoUrl = () => getConfigs().GOOGLE_USERINFO_URL;

/**
 * Google Identity Services script for "Continue with Google" - a fixed public Google URL.
 */
export const GOOGLE_GSI_CLIENT_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

// start.sh writes every REACT_APP_* variable into appconfig.js, so an unset or placeholder
// value can arrive as one of these strings rather than empty.
const unsetConfigValue = (value) => (['', 'false', 'undefined', 'null'].includes(String(value ?? '').trim()) ? '' : value);

/**
 * The Apple Services ID (client_id) for "Continue with Apple" - empty string when unconfigured.
 */
export const getAppleClientId = () => unsetConfigValue(getConfigs().APPLE_CLIENT_ID);

/**
 * Apple's redirect URI - this environment's /apple-callback.html, matching the Return URL
 * registered with Apple exactly. Empty string when unconfigured.
 */
export const getAppleRedirectUri = () => unsetConfigValue(getConfigs().APPLE_REDIRECT_URI);

/**
 * Sign in with Apple JS - a fixed public Apple URL.
 */
export const APPLE_ID_AUTH_SCRIPT_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
